import * as React from 'react';

/**
 * Cell with link component.
 * @param {Object} params
 * @returns {JSX.Element}
 */
export default function (params) {
  const {value, column, row, fields} = params;

  if (row && row[column] && row[`${column}_url`]) {
    let attributeProps = {};
    if (fields && fields[column]) {
      attributeProps = fields[column]['attributes'].reduce((acc, attr) => {
        acc[attr.key] = attr.value;
        return acc;
      }, {});
    }

    return (
      <div className='cell cell--url'>
        <a href={row[`${column}_url`]} {...attributeProps}>
          {value}
        </a>
      </div>
    );
  }

  return (
    <div className='cell cell--url'>
      {value}
    </div>
  );
}
